import axios from "axios";
import { baseApiUrl } from "../../env";
import axiosInstance from "../../Axios/axios";

/*================== Api url =================*/
const baseUrl =baseApiUrl;
const userInfo = JSON.parse(localStorage.getItem("userInfo"));

const GetOrderView = async (body) => {
  const viewOrderApi = `${baseUrl}/api/v1/Order/GetOrderView?orderId=${body.orderId}&userId=${body.userId}`;
  return await axiosInstance.post(viewOrderApi);
};

/**=======================
 *     DataGrid data
 *========================**/
const GetOrders = `${baseUrl}/api/v1/DesigningDepartment/GetOrdersAssignToDesigner`;
const GetOrderData = async (getOrderBody) => {
  return await axiosInstance.post(GetOrders, getOrderBody.queryKey[1]);
};

/**=======================
 *     GetAllOrganizationUnit
 *========================**/
const GetAllOrganizationUnit = () => {
  const OrganizationUnitApi = `${baseUrl}/api/v1/OrganizationUnit/GetOrganizationUnitForOrder`;
  return axiosInstance.get(OrganizationUnitApi);
};

/**=======================
 *     Message description Organation Post
 *========================**/
const PostOrganizationUnit = async (data) => {
  const PostOrganizationUnitApi = `${baseUrl}/api/v1/UnitDescription/AddUnitDescription`;
  const Body = {
    orderId: data.orderId,
    description: data.inputMessage,
    title: "",
    descriptionType:data.messageType,
    organizationUnits:data.unitsSend,
  };

  return await axiosInstance.post(PostOrganizationUnitApi, Body);
};

/**=======================
 *     Get recive organization messsages send
 *========================**/
const GetMessageOrganizationSend = async (body) => {
  const user = userInfo.userId;
  const tokenn = localStorage.getItem("accessToken");
  const OrgSendApi = `${baseUrl}/api/v1/UnitDescription/GetUnitDescriptions`;
  const data=body;
  return await axiosInstance.get(`${OrgSendApi}?orderId=${data.orderId}&userId=${data.userId}`);
};

/**=======================
 *     Edite organization message send
 *========================**/
const EditMessageOrganizationSend = async (messageData) => {
  const body=messageData.queryKey[1];
  const api = `${baseUrl}/api/v1/UnitDescription/UpdateUnitDescription`;
  return await axiosInstance.post(api,body);
};
const editOrderDescription=async(descriptData)=>{
  const api = `${baseUrl}/api/v1/UnitDescription/UpdateUnitDescription`;
  return await axiosInstance.post(api,descriptData);
}
/**=======================
 *     Delet Organization Message
 *========================**/

const deleteMessageOrganization = async (id) => {
  const api = `${baseUrl}/api/v1/UnitDescription/DeleteUnitDescription?unitDescriptionId=${id}`;
  return await axiosInstance.delete(api);
};
/**=======================
 *     Compair Order Type List
 *========================**/
const compaireOrder = async (orderId) => {
  const api = `${baseUrl}/api/v1/Order/GetOrderReferences?orderId=${orderId}`;
  return await axiosInstance.get(api);
};
/**=======================
 *    Compair Order data prevOrder select
 *========================**/
const compaireOrderDataInfo = async (orderId) => {
  const api = `${baseUrl}/api/v1/Order/GetSingleOrderByReferenceId?orderId=${orderId}`;
  return await axiosInstance.get(api);
};
/**=======================
 *     Get SignalR Message
 *========================**/
const getMessageSignalr = async (orderId) => {
  const api = `${baseUrl}/api/v1/Message/GetAllMessage`;
  const body = { orderId: orderId };

  return await axiosInstance.post(api, body);
};
/**==============================================
 *                Export
 *=============================================**/

const getdesigningDepartment=async()=>{
const api=`${baseUrl}/api/v1/DesigningDepartment/GetProcessDropDown`;
return await axiosInstance.get(api)
}
const changeOrderStatus=async(body)=>{
let{controler,...rest}=body
 return await axiosInstance.post(`${controler}/ChangeOrderStatus`,rest)
}
const changeOrderState=async(body)=>{
let{controler,...rest}=body

 return await axiosInstance.post(`${controler}/ChangeState`,rest)
}
const addOrderDamageReport = async (orderData) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/OrderDamage/AddOrderDamage`,
    orderData
    ,
    {
      headers:{
        "Content-Type": "multipart/form-data"
      }
    }
  );
};

// http://192.168.3.17:91/api/v1/OrderDamage/EditOrderDamage
const editOrderDamageReport = async (orderData) => {
  return await axiosInstance.post(
    `${baseApiUrl}/api/v1/OrderDamage/EditOrderDamage`,
    orderData
    ,
    {
      headers:{
        "Content-Type": "multipart/form-data"
      }
    }
  );
};







const getGroupCausesDamage=async()=>{
  return await axiosInstance.get(`${baseApiUrl}/api/v1/GroupCausesDamage/GetAllGroupCausesDamagesWithTotal`);

}
const getOrderDamage=async({queryKey})=>{
  let orderId=queryKey[1];
  return await axiosInstance.post(`${baseApiUrl}/api/v1/OrderDamage/GetOrderDamage`,orderId)
}
const deleteOrderDamgeImage=(imageId)=>{
  // http://192.168.3.17:91/api/v1/OrderDamage/DeleteOrderDamageImage?imageId=3fa85f64-5717-4562-b3fc-2c963f66afa6

  return axiosInstance.delete(`${baseApiUrl}/api/v1/OrderDamage/DeleteOrderDamageImage?imageId=${imageId}`)
}

// http://192.168.3.17:91/api/v1/OrderDamage/GetRelatedOrders
const getRelatedOrders=async({queryKey})=>{
  let body=queryKey[1];
  return await axiosInstance.post(`${baseApiUrl}/api/v1/OrderDamage/GetRelatedOrders`,body)
}




// http://192.168.3.17:91/api/v1/Damage/GetAllDamageItems
const getAllDamageItems=async({queryKey})=>{
  let damageId=queryKey[1];
  return await axiosInstance.post(`${baseApiUrl}/api/v1/Damage/GetAllDamageItems`,damageId)
}

// http://192.168.3.17:91/api/v1/Damage/AddOrUpdateDamageItem

const addOrUpdateDamageItem=(body)=>{
  return axiosInstance.post(`${baseApiUrl}/api/v1/Damage/AddOrUpdateDamageItem`,body)
}


const deleteItemDamage=(damageItemId)=>{
  return axiosInstance.delete(`${baseApiUrl}/api/v1/Damage/DeleteDamageItem?damageItemId=${damageItemId}`)
}












export {
  GetOrderView,
  GetAllOrganizationUnit,
  PostOrganizationUnit,
  GetMessageOrganizationSend,
  EditMessageOrganizationSend,
  deleteMessageOrganization,
  GetOrderData,
  compaireOrder,
  compaireOrderDataInfo,
  getMessageSignalr,
  editOrderDescription,
  getdesigningDepartment,
  changeOrderStatus,
  changeOrderState,
  addOrderDamageReport,
  getGroupCausesDamage,
  getOrderDamage,
  deleteOrderDamgeImage,
  getRelatedOrders,
  getAllDamageItems,
  addOrUpdateDamageItem,
  deleteItemDamage,
  editOrderDamageReport

};
